import {useQuery} from "react-query";
import * as api from "../api/easeedesk/apis";

const getDevices = async (ticketId) => {
    return await api.fetchTicketDevices(ticketId);
};

export default function useTicketDevices(ticketId) {
    return useQuery([
        'ticket_devices',
        {ticketId}
    ], () => getDevices(ticketId), {refetchOnWindowFocus: false});
}
